// Port of api/fuel/app/classes/filter/search/games/filters/query/game/version/size/length.php
import { rangeActive } from 'offline/filter/core/search/unit'
export default {
	name: 'version.size.length',
	priority: 65,
	require: function(config, filter) { return filter.version && filter.version.size && rangeActive(filter.version.size.length, 0, 9999) },
	run: function(config, filter, data, query) {
		if (filter.version.size.length.from > 0) query.where('v.game_version_storage_length', '>=', filter.version.size.length.from)
		if (filter.version.size.length.to < 9999) query.where('v.game_version_storage_length', '<=', filter.version.size.length.to)
	}
}
